export default __webpack_public_path__ + "static/media/AAVE.e.b747f0c6.png";